import React, { useState, useEffect, useCallback } from "react";
import LeftSidebar from "../../components/LeftSidebar/LeftSidebar";
import Avatar from "../../components/Avatar/Avatar";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBirthdayCake, faPen } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import EditProfileForm from "./EditProfileForm";
import ProfileBio from "./ProfileBio";
import "./UserProfile.css";
import { giveBadgeForUpvote, giveBadgeForAnswer } from "../../actions/users";
import Modal from "../../components/Modals/Modal";

const UserProfile = () => {
  const { id } = useParams();
  const [Switch, setSwitch] = useState(false);
  const currentUser = useSelector((state) => state.currentUserReducer);
  const users = useSelector((state) => state.usersReducer);
  const currentProfile = users.filter((user) => user._id === id)[0];
  const existingUpvoteBadge = currentUser?.result?.upvotebadge;
  const existingAnswerBadge = currentUser?.result?.answerbadge;
  const [upvoteBadge, setUpvoteBadge] = useState(existingUpvoteBadge);
  const [answerBadge, setAnswerBadge] = useState(existingAnswerBadge);

  const [showModal, setShowModal] = useState();
  const [showConfetti, setShowConfetti] = useState(false);
  const dispatch = useDispatch();

  const questionsList = useSelector((state) => state.questionsReducer);

  const badgeForUpvote = questionsList?.data?.filter(
    (user) => user.upVote.length > 5
  );

  const badgeForAnswers = questionsList?.data?.filter(
    (user) => user.noOfAnswers > 0
  );

  const upVoteBadgeReceiver = badgeForUpvote?.filter(
    (user) => user.userId === currentUser.result._id
  );

  const answerBadgeReceiver = badgeForAnswers?.filter((user) =>
    user.answer.find((user) => user.userId === currentUser.result._id)
  );

  const upvoteBadgeHandler = () => {
    if (upVoteBadgeReceiver?.length !== 0) {
      setUpvoteBadge("Explorer");
      setShowModal({
        title: "Congratulations 🥳",
        message: `You got a ${upvoteBadge} badge for getting most upVotes on your question`,
      });
      setShowConfetti(true);
    }

    if (upVoteBadgeReceiver?.length === 0) {
      setShowModal({
        title: "Sorry 😥",
        message: "You didn't get any badge, Better luck next time",
      });
      setShowConfetti(false);
    }
  };

  const answerBadgeHandler = () => {
    if (answerBadgeReceiver?.length > 5) {
      setAnswerBadge("Amateur");
      setShowModal({
        title: "Congratulations 🥳",
        message: `You got a ${answerBadge} badge for giving most number of answers`,
      });
      setShowConfetti(true);
    }
    if (answerBadgeReceiver.length === 0) {
      setShowModal({
        title: "Sorry 😥",
        message: "You didn't get any badge, Better luck next time",
      });
      setShowConfetti(false);
    }
  };

  useEffect(() => {
    if (!existingUpvoteBadge) {
      dispatch(
        giveBadgeForUpvote(currentUser?.result?._id, {
          upvotebadge: upvoteBadge,
        })
      );
    }
    if (!existingAnswerBadge) {
      dispatch(
        giveBadgeForAnswer(currentUser?.result?._id, {
          answerbadge: answerBadge,
        })
      );
    }
  }, [dispatch, existingUpvoteBadge, existingAnswerBadge]);

  const cancelHandler = () => {
    setShowModal(null);
  };

  return (
    <div>
      {showModal && (
        <>
          <Modal
            title={showModal.title}
            message={showModal.message}
            onConfirm={cancelHandler}
            showConfetti={showConfetti}
          />
        </>
      )}
      <div className="home-container-1">
        <LeftSidebar />
        <div className="home-container-2">
          <section>
            <div className="user-details-container">
              <div className="user-details">
                <Avatar
                  backgroundColor="purple"
                  color="white"
                  fontSize="50px"
                  px="40px"
                  py="30px"
                >
                  {currentProfile?.name.charAt(0).toUpperCase()}
                </Avatar>
                <div className="user-name">
                  <h1>{currentProfile?.name}</h1>
                  <p>
                    <FontAwesomeIcon icon={faBirthdayCake} /> Joined{" "}
                    {moment(currentProfile?.joinedOn).fromNow()}
                  </p>
                </div>
              </div>
              {currentUser?.result._id === id && (
                <button
                  type="button"
                  onClick={() => setSwitch(true)}
                  className="edit-profile-btn"
                >
                  <FontAwesomeIcon icon={faPen} /> Edit Profile
                </button>
              )}
            </div>

            <>
              {Switch ? (
                <EditProfileForm
                  currentUser={currentUser}
                  setSwitch={setSwitch}
                />
              ) : (
                <ProfileBio
                  currentProfile={currentProfile}
                  upvoteBadgeHandler={upvoteBadgeHandler}
                  answerBadgeHandler={answerBadgeHandler}
                  existingUpvoteBadge={existingUpvoteBadge}
                  existingAnswerBadge={existingAnswerBadge}
                />
              )}
            </>
          </section>
        </div>
      </div>
    </div>
  );
};

export default React.memo(UserProfile);
